export default __webpack_public_path__ + "static/media/dashboard-menu.ac9323c7.svg";